import axios from "axios";
import {
  FETCH_CALCULATIONS,
  CREATE_FORMULA,
  CREATE_TREATMENT,
  FETCH_TREATMENT,
  DELETE_CALCULATORS,
  DELETE_TREATMENTS,
  SHOW_CALC,
  FETCH_CALCULATIONS_BY_TYPE,
  SHOW_TREATMENT,
  UPDATE_CALCULATOR,
  TOTAL_ONGOING_TREATMENTS,
  TOTAL_PENDING_TREATMENTS,
  UPDATE_TREATMENT,
  interceptor
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);

export function createFormula(formula) {
  return {
    type: CREATE_FORMULA,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/calculations/`, formula, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchCalculations() {
  return {
    type: FETCH_CALCULATIONS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/calculations/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchCalculationsByType(type) {
  return {
    type: FETCH_CALCULATIONS_BY_TYPE,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/calculations/calculationsByType/${type}`,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function createTreatment(treatment) {
  return {
    type: CREATE_TREATMENT,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/treatment/`, treatment, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchTreatments() {
  return {
    type: FETCH_TREATMENT,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/treatment/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function getPendingTreatmentsCount() {
  return {
    type: TOTAL_PENDING_TREATMENTS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/treatment/pending_count`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function getOngoingTreatmentsCount() {
  return {
    type: TOTAL_ONGOING_TREATMENTS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/treatment/ongoing_count`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteCalculator(selected) {
  return {
    type: DELETE_CALCULATORS,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/calculations/${selected}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteTreatment(selected) {
  return {
    type: DELETE_TREATMENTS,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/treatment/${selected}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function showCal(id) {
  return {
    type: SHOW_CALC,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/calculations/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function showTreatment(id) {
  return {
    type: SHOW_TREATMENT,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/treatment/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateCalculator(id, data) {
  return {
    type: UPDATE_CALCULATOR,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/calculations/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateTreatment(id,treatment) {  
  return {
    type: UPDATE_TREATMENT,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/treatment/${id}`, treatment, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
